module.exports = __webpack_public_path__ + "img/crm.49316ef5.svg";